export default __webpack_public_path__ + "static/media/fees1.5233a747.png";